import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import config from "../../config";
import { FaTrash, FaEdit } from "react-icons/fa";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Switch from "react-switch";
import PermissionGuard from "../Guards/PermissionGuard";
import { PERMISSIONS } from "../../constants/permissions";

axios.defaults.withCredentials = true;

const CourseTable = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  // Fetch all courses
  
  const fetchCourses = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiBaseUrl}/api/Course/GetAllCourses`, {
        headers: {
          "HeaderKey": "G3)1KQh8dW{}5rhWiZtsz_p[K]9!t9wvM!!QOua6Bb;dL@.FX;+xIuInN!Ux{!d,-Gs8($Jasz{76fM@XI>)A{{%iat9FyU^;k%mlxkbd8AR(]v8IoFb=3KbP}M5u:@u"
        },
        withCredentials: true,
      });
      setCourses(response.data);
    } catch (error) {
      toast.error("خطا در برقراری ارتباط", { autoClose: false });
      if (error.response && error.response.status === 401) {
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const filteredCourses = courses.filter(course =>
    course.title.toLowerCase().includes(searchText.toLowerCase()) ||
    course.price.toString().includes(searchText)
  );
  // Prompt user before confirming deletion
  const handleDelete = (id) => {
    toast.warn(
      <div className="text-right font-custom">
        <p>آیا از حذف این دوره مطمئن هستید؟</p>
        <div className="flex justify-end gap-2 mt-2">
          <button
            className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded"
            onClick={() => confirmDelete(id)}
          >
            حذف
          </button>
          <button
            className="bg-gray-500 hover:bg-gray-700 text-white px-3 py-1 rounded"
            onClick={() => toast.dismiss()}
          >
            انصراف
          </button>
        </div>
      </div>,
        { autoClose: false }
    );
    };
    const handleSwitchChange = (courseId, newStatus) => {
        togglePublishStatus(courseId, newStatus);
    };
    const togglePublishStatus = async (courseId, newStatus) => {
        try {
            const response = await axios.post(
                `${config.apiBaseUrl}/api/Course/TogglePublishStatus`,
                { id: courseId, isPublished: newStatus },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "HeaderKey": "G3)1KQh8dW{}5rhWiZtsz_p[K]9!t9wvM!!QOua6Bb;dL@.FX;+xIuInN!Ux{!d,-Gs8($Jasz{76fM@XI>)A{{%iat9FyU^;k%mlxkbd8AR(]v8IoFb=3KbP}M5u:@u",
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200) {
                setCourses(prevCourses =>
                    prevCourses.map(course =>
                        course.courseId === courseId ? { ...course, isPublished: newStatus } : course
                    )
                );
                toast.success(<p dir="rtl" className="font-custom">وضعیت انتشار دوره با موفقیت تغییر کرد</p>, { autoClose: 3000 });
            } else {
                toast.error("خطا در تغییر وضعیت انتشار دوره!", { autoClose: 3000 });
            }
        } catch (error) {
            toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
        }
    };
  // Confirm and delete the course
  const confirmDelete = async (id) => {
    try {
      toast.dismiss();
      const response = await axios.post(
        `${config.apiBaseUrl}/api/Course/RemoveCourse`,
        id , 
        {
          withCredentials: true,
          headers: { 
            "Content-Type": "application/json",
            "HeaderKey": config.HeaderKey
          },
        }
      );

      if (response.status === 200) {
        setCourses(prev => prev.filter(course => course.courseId !== id));
        toast.success("دوره با موفقیت حذف شد!", { autoClose: 3000 });
      } else {
        toast.error("خطا در حذف دوره!", { autoClose: 3000 });
      }
    } catch (error) {
      toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
      if (error.response && error.response.status === 401) {
        navigate("/");
      }
    }
  };
const subHeaderComponent = (
  <input
    type="text"
    placeholder="جستجو..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    className="border px-3 py-2 rounded-md text-sm focus:outline-none"
  />
);
  // Define table columns
  const columns = [
    {
      name: "",
      cell: (row) => (
        <img
          src={config.apiBaseUrl +  row.pictureUrl}
          alt={row.title}
          className="w-16 h-16 object-cover rounded"
        />
      ),
      width: "100px",
      style: { padding: "8px" },
    },
    {
      name: "عنوان",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "قیمت",
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: "منتشر شده",
      cell: (row) => (
        <Switch
          onChange={() => handleSwitchChange(row.courseId, !row.isPublished)}
          checked={row.isPublished}
          onColor="#27ff00" // Tailwind green-400
          offColor="#ff1a00" // Tailwind red-400
          onHandleColor="#1c7510" // Tailwind green-500
          offHandleColor="#751010" // Tailwind red-500
          checkedIcon={
            <div className="text-[10px] text-white pl-1 w-6 h-6 flex items-center justify-center text-center">
             </div>
          }
          uncheckedIcon={
            <div className="text-[10px] text-white pl-1 w-6 h-6 flex items-center justify-center text-center">
 
            </div>
          }
          className="react-switch"
          height={28} // 🔹 Increased height
          width={50} // 🔹 Increased width
        />
      ),
        sortable: true,
    },
    {
      name: "تاریخ ایجاد",
      selector: (row) => new Date(row.createdAt).toLocaleDateString("fa-IR"),
      sortable: true,
    },
    {
      name: "عملیات",
      cell: (row) => (
        <div className="flex gap-3">
          <PermissionGuard permission={PERMISSIONS.COURSES_EDIT}>
            <button
              onClick={() => navigate("/dashboard/courses/updatecourse", { state: { course: row } })}
              className="text-blue-500 hover:text-blue-700 transition-all"
            >
              <FaEdit size={18} />
            </button>
          </PermissionGuard>

          <PermissionGuard permission={PERMISSIONS.COURSES_DELETE}>
            <button
              onClick={() => handleDelete(row.courseId)}
              className="text-red-500 hover:text-red-700 transition-all"
            >
              <FaTrash size={18} />
            </button>
          </PermissionGuard>
        </div>
      ),
      ignoreRowClick: true,
      
    },
  ];

  return (
    <div className="font-custom rtl text-right p-5">
      <h1 className="text-center text-xl mt-5 mb-5">لیست دوره‌های سامانه</h1>
      
      {/* Button to add a new course */}
      <PermissionGuard permission={PERMISSIONS.COURSES_CREATE}>
        <button
          className="bg-green-700 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-full shadow-md transition duration-300 mb-5"
          onClick={() => navigate("/dashboard/courses/addcourse")}
        >
          + جدید
        </button>
      </PermissionGuard>

      <div className="w-full shadow-lg">
        <DataTable
          columns={columns}
          data={filteredCourses}
          pagination
          highlightOnHover
          subHeader
          subHeaderComponent={subHeaderComponent}
          responsive
          progressPending={loading}
          className="w-full text-right"
          customStyles={{
            table: {
              style: {
                direction: "rtl",
              },
            },
            rows: {
              style: {
                direction: "rtl",
                textAlign: "right",
              },
            },
            headCells: {
              style: {
                textAlign: "right",
                fontWeight: "bold",
                direction: "rtl",
              },
            },
            cells: {
              style: {
                textAlign: "right",
                direction: "rtl",
              },
            },
          }}
        />
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        className={"font-custom text-center rtl"}
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </div>
  );
};

export default CourseTable;
